import Vue from "vue";
import VueResource from "vue-resource";

import {
  API_ROOT,
  API_ROOT_V2,
  API_PARTICIPANT_PORTAL,
  COGNITO_API_US_WEB_ROOT,
  auth,
  signin,
  forgotPassword,
  sendOtp,
  validateOtp,
  resetPassword,
  studyManagement,
  users,
  token,
  refresh,
  participantManagement,
  participants,
  participantsPortalLogin,
  generatejwttoken,
  forgotUsername,
  user,
  createUsername,
  otp,
  editEmail,
  send,
  profile,
  verifyOtp,
  attemptleft,
  create,
  verify,
  code,
  login,
  twofa,
  twofaOtp
} from "./urls";

Vue.use(VueResource);

const authResource = Vue.resource(`${API_ROOT}${auth}/${signin}`);
const authParticipantResource = Vue.resource(`${API_PARTICIPANT_PORTAL}${participantManagement}${participants}/${participantsPortalLogin}`);
const forgotPwdResource = Vue.resource(`${API_ROOT}${auth}/${forgotPassword}`);
const sendOtpResource = Vue.resource(`${API_ROOT}${auth}/${sendOtp}`);
const validateOtpResource = Vue.resource(`${API_ROOT}${auth}/${validateOtp}`);
const setPasswordResource = Vue.resource(`${API_ROOT}${auth}/${resetPassword}`);
const refreshTokenResource = Vue.resource(`${API_ROOT}${studyManagement}${users}{/userId}/${refresh}`);
const refreshTokenWithSiteId = Vue.resource(`${API_ROOT_V2}${studyManagement}${users}{/userId}/${refresh}`);
const setCheckPasswordResource = Vue.resource(`${API_ROOT}${auth}/${resetPassword}?isOnlyCheck=true`);
const refreshParticipantToken = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}/${token}`, {}, { update: { method: "PUT" } });

const javaCompatibleAccessTokenResource = Vue.resource(`${API_ROOT}${auth}/${generatejwttoken}`);
const forgotUsernameResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${token}/${forgotUsername}`);
const createUsernameTokenResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${user}/${createUsername}`);
const sendOtpToNewEmailResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${otp}/${editEmail}/${send}`);
const verifyNewEmailOtpResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${user}/${profile}/${verifyOtp}`);
const verifyForgottenUsernameResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${user}/${forgotUsername}`);
const updateFailedLoginAttemptResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${user}/${attemptleft}`, {}, { update: { method: "PUT" } });
const resetLoginLockedTokenResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${user}/${token}/${create}`);
const updateLockedStatusResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${user}/${token}/${verify}`, {}, { update: { method: "PUT" } });
const cognitoAccessTokenResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${auth}/${verify}/${code}`);
const mfaAuthResource = Vue.resource(`${API_ROOT}${auth}/${twofa}`);
const mfaCodeResendResource = Vue.resource(`${API_ROOT}${auth}/${twofaOtp}`);

//61129 start
const sendMobileOtpResource = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${send}/${login}/${otp}`);

export function loginUserFact(data) {
  //webPortalLogIn key is added to identify that the sign in API is called from WEB UI OR by Backedn Webservice internally
  data.webPortalLogIn = true;
  data.strictWebLogin = true;
  return authResource.save(data);
}

export function loginParticipantFact(data) {
  //webPortalLogIn key is added to identify that the sign in API is called from WEB UI OR by Backedn Webservice internally
  data.webPortalLogIn = true;
  return authParticipantResource.save(data);
}

export function sendForgotPwdEmailFact(data) {
  return forgotPwdResource.save(data);
}

export function sendOtpToMobileFact(data) {
  return sendOtpResource.save(data);
}

export function verifyOtpFact(data) {
  return validateOtpResource.save(data);
}

export function setNewPasswordFact(data) {
  return setPasswordResource.save(data);
}

export function getRefreshTokenFact(userId, data) {
  return refreshTokenResource.save({ userId }, data);
}

export function getParticipantRefreshTokenFact(data) {
  return refreshParticipantToken.update(data);
}

export function setNewCheckPasswordFact(data) {
  return setCheckPasswordResource.save(data);
}

export function getRefreshToken(userId, siteId, data) {
  return refreshTokenWithSiteId.save({ userId, siteId }, data);
}

export function getJavaCompatibleAccessToken(queryParams) {
  return javaCompatibleAccessTokenResource.save(queryParams, {});
}

export function forgotUsernameFact(data) {
  data.requestFrom = "web";
  return forgotUsernameResource.save(data);
}

export function getTokenToCreateUsername(data) {
  data.requestFrom = "web";
  return createUsernameTokenResource.save(data);
}

export function sendOtpToUserNewEmail(data) {
  return sendOtpToNewEmailResource.save(data);
}

export function verifyNewEmailOtp(data) {
  return verifyNewEmailOtpResource.save(data);
}

export function verifyForgottenUsername(data) {
  return verifyForgottenUsernameResource.save(data);
}

export function updateFailedLoginAttempt(data) {
  return updateFailedLoginAttemptResource.update(data);
}

export function resetLoginAttemptNLockStatus(data) {
  return resetLoginLockedTokenResource.save(data);
}

export function updateLockedStatus(data) {
  return updateLockedStatusResource.update(data);
}

export function getCognitoAccessTokenFromSSOCode(authCode) {
  return cognitoAccessTokenResource.get({ authCode });
}
//61129 start
export function sendMobileOtpFact(mobileCountryCodeOld, phone, studyId) {
  let mobileCountryCode = mobileCountryCodeOld;
  mobileCountryCode = mobileCountryCode.toString()[0] == "+" ? mobileCountryCode : "+" + mobileCountryCode;
  const payload = studyId && studyId != "" ? { mobileCountryCode, phone, studyId } : { mobileCountryCode, phone };
  return sendMobileOtpResource.save(payload, {});
}
export function mfaValidateFact(data) {
  return mfaAuthResource.save(data);
}
export function mfaResendCodeFact(data) {
  return mfaCodeResendResource.save(data);
}
